import React from 'react';
export function TimelineSection() {
  const timelineItems = [{
    period: 'September 2026:',
    events: ['Randomisation of classes to intervention or control groups.', 'Administer baseline STAR assessments with all students.', 'Set up all intervention classes on the Eedi platform.', 'Attend training sessions with all participating teachers.', 'Designate a lead teacher/coordinator within your school.']
  }, {
    period: 'October 2026 onwards:',
    events: ["Intervention classes engage with Eedi's full set of features weekly, including diagnostics, interventions, and tutor support.", 'Control classes continue with business-as-usual teaching.', 'Regular check-ins with the Eedi research team.']
  }, {
    period: 'January 2027:',
    events: ['Administer the midline STAR assessments with all students.']
  }, {
    period: 'June - July 2027:',
    events: ['Administer endline STAR assessments with all students.', 'Final data collection and teacher surveys.', 'All classes gain full access to Eedi for the following academic year.']
  }];
  return <div className="bg-white rounded-xl shadow-md p-6" data-id="element-38">
      <h2 className="text-2xl font-bold mb-6" data-id="element-39">Research Study Timeline</h2>
      <div className="space-y-8" data-id="element-40">
        {timelineItems.map((item, index) => <div key={index} data-id="element-41">
            <h3 className="font-bold text-lg text-purple-700 mb-3" data-id="element-42">
              {item.period}
            </h3>
            <ul className="space-y-2 pl-5" data-id="element-43">
              {item.events.map((event, eventIndex) => <li key={eventIndex} className="flex items-start" data-id="element-44">
                  <span className="text-purple-600 mr-2" data-id="element-45">●</span>
                  <span className="text-gray-700" data-id="element-46">{event}</span>
                </li>)}
            </ul>
          </div>)}
      </div>
    </div>;
}